import React from 'react';

import AboutPage from './AboutPage';

async function action() {
  return {
    title: 'About Shadower | The Job Shadowing Marketplace. Try any job!',
    description:
      'Find experts to shadow in real life and gain hands-on training, real-world knowledge and expert instruction.',
    chunks: ['about'],
    component: <AboutPage />,
  };
}

export default action;
